import { Component, Input, inject } from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';
import { VerticalStepperService } from '../../services/vertical-stepper/vertical-stepper.service';

@Component({
  standalone: false,
  selector: 'irembogov-stepper',
  templateUrl: './irembogov-stepper.component.html',
  styleUrls: ['./irembogov-stepper.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: IrembogovStepperComponent }],
})
export class IrembogovStepperComponent extends CdkStepper {
  private readonly verticalStepperService = inject(VerticalStepperService);

  @Input() enableButtonNavigation = true;

  @Input() set shouldShowDraft(value: boolean) {
    this.verticalStepperService.setShouldShowDraft(value);
  }
}
